import { render, staticRenderFns } from "./TerminalPage.vue?vue&type=template&id=6fa84cb1&scoped=true"
import script from "./TerminalPage.vue?vue&type=script&lang=js"
export * from "./TerminalPage.vue?vue&type=script&lang=js"
import style0 from "./TerminalPage.vue?vue&type=style&index=0&id=6fa84cb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa84cb1",
  null
  
)

export default component.exports